export default [
  {
    path: 'settings',
    name: 'settings',
    component: () => import('@/views/pages/settings/Index.vue'),
    meta: {
      pageTitle: 'Settings',
      breadcrumb: [
        {
          text: 'Settings',
          active: true,
        },
      ],
      resource: 'Settings',
    },
  },
]
